/* src/app/components/menu-options/menu-options.component.scss */
.dropdown-menu.show {
  bottom: 100% !important;
}
.accordion-item {
  border: none !important;
}
a.dropdown-item:hover,
button.dropdown-item:hover {
  background-color: #fff !important;
}
.accordion-button:focus {
  box-shadow: none !important;
}
.accordion-button:hover {
  background-color: transparent !important;
}
.accordion-button {
  display: flex;
  flex-direction: column;
  padding: 15px 0px 0px 0px !important;
}
.accordion-button img {
  max-height: 2.5em !important;
  border-radius: 100% !important;
}
.accordion-header {
  max-width: 100px;
  margin: auto;
  height: 100px;
}
.accordion-button::after {
  background-image: none !important;
}
.empty-head-icon {
  box-shadow: 0 1px 6px #a0afdc, 0 0 #a0afdc !important;
  background: #fff !important;
}
.accordion-button:not(.collapsed) {
  box-shadow: none !important;
  background: transparent !important;
}
.empty-head-icon {
  font-size: 1.5rem;
  padding: 2px;
}
.accordion-body li a {
  align-items: center;
}
.floating {
  animation-name: floating;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  margin-left: 30px;
  margin-top: 5px;
}
@keyframes floating {
  from {
    transform: translate(0, 0px);
  }
  65% {
    transform: translate(0, 15px);
  }
  to {
    transform: translate(0, 0px);
  }
}
/*# sourceMappingURL=menu-options.component.css.map */
